import { Dialog, AutoFitComponent, AutoFitMutilComp } from 'components'
import Confirm from '@/components/common/confirm/index.js'

const comps = {
  AutoFitComponent,
  AutoFitMutilComp,
  Dialog,
}

const methods = {
  Confirm,
}

export default {
  install(Vue) {
    Object.keys(comps).forEach((key) => {
      Vue.component(key, comps[key])
    })
    Object.keys(methods).forEach((key) => {
      Vue.use(methods[key])
    })
  },
}
